module.exports = __webpack_public_path__ + "static-portal/img/11.fw.1321b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/11.fw.png
// module id = 7VrK
// module chunks = 4